var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{on:{"click":_vm.callSpeakFunc}},[_vm._v("播放")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }